// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ComponentListContentSlice_main__sR9EF {
    width: 100%;
    height: 100%;
}

.ComponentListContentSlice_header__--jq1 {
    display: flex;
    justify-content: space-between;
    width: 100%;
}

.ComponentListContentSlice_modal_slice__i\\+nlE .ant-modal-content {
    width: 650px;
}

.ComponentListContentSlice_modal_content__W-L5m {
    display: flex;
    justify-content: space-between;
    width: 100%;
    height: 400px;
}

.ComponentListContentSlice_content_title__62ukg {
    width: 20%;
    height: 100%;
    padding-top: 20px;
}

.ComponentListContentSlice_content_box__GK7Q0 {
    width: 80%;
    height: 100%;
    padding: 20px;
    overflow-x: hidden;
    overflow-y: scroll;
    border-radius: 6px;
    background-color: #f8f8fa;
}

/* 自定义滚动条 */
.ComponentListContentSlice_content_box__GK7Q0::-webkit-scrollbar {/*滚动条整体样式*/
    -webkit-appearance: none;
    width: 10px;
    height: 10px;
}

.ComponentListContentSlice_content_box__GK7Q0::-webkit-scrollbar-thumb {/*滚动条里面小方块*/
    cursor: pointer;
    border-radius: 5px;
    background: #e9e9e9;
    -webkit-transition: color .2s ease;
    transition: color .2s ease;
}

.ComponentListContentSlice_content_box__GK7Q0::-webkit-scrollbar-thumb:hover {
    background: #e3e3e3;
}

.ComponentListContentSlice_slice_card_content__7wwht {
    width: 100%;
    height: 100%;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    overflow: hidden;
    text-overflow: ellipsis;
}`, "",{"version":3,"sources":["webpack://./src/pages/admin/components/ComponentListContentSlice/index.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,WAAW;AACf;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA,WAAW;AACX,kEAAiC,UAAU;IACvC,wBAAwB;IACxB,WAAW;IACX,YAAY;AAChB;;AAEA,wEAAuC,WAAW;IAC9C,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IAEnB,kCAA0B;IAA1B,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,4BAA4B;IAC5B,qBAAqB;IACrB,gBAAgB;IAChB,uBAAuB;AAC3B","sourcesContent":[".main {\n    width: 100%;\n    height: 100%;\n}\n\n.header {\n    display: flex;\n    justify-content: space-between;\n    width: 100%;\n}\n\n.modal_slice :global(.ant-modal-content) {\n    width: 650px;\n}\n\n.modal_content {\n    display: flex;\n    justify-content: space-between;\n    width: 100%;\n    height: 400px;\n}\n\n.content_title {\n    width: 20%;\n    height: 100%;\n    padding-top: 20px;\n}\n\n.content_box {\n    width: 80%;\n    height: 100%;\n    padding: 20px;\n    overflow-x: hidden;\n    overflow-y: scroll;\n    border-radius: 6px;\n    background-color: #f8f8fa;\n}\n\n/* 自定义滚动条 */\n.content_box::-webkit-scrollbar {/*滚动条整体样式*/\n    -webkit-appearance: none;\n    width: 10px;\n    height: 10px;\n}\n\n.content_box::-webkit-scrollbar-thumb {/*滚动条里面小方块*/\n    cursor: pointer;\n    border-radius: 5px;\n    background: #e9e9e9;\n    -webkit-transition: color .2s ease;\n    transition: color .2s ease;\n}\n\n.content_box::-webkit-scrollbar-thumb:hover {\n    background: #e3e3e3;\n}\n\n.slice_card_content {\n    width: 100%;\n    height: 100%;\n    display: -webkit-box;\n    -webkit-box-orient: vertical;\n    -webkit-line-clamp: 3;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": `ComponentListContentSlice_main__sR9EF`,
	"header": `ComponentListContentSlice_header__--jq1`,
	"modal_slice": `ComponentListContentSlice_modal_slice__i+nlE`,
	"modal_content": `ComponentListContentSlice_modal_content__W-L5m`,
	"content_title": `ComponentListContentSlice_content_title__62ukg`,
	"content_box": `ComponentListContentSlice_content_box__GK7Q0`,
	"slice_card_content": `ComponentListContentSlice_slice_card_content__7wwht`
};
export default ___CSS_LOADER_EXPORT___;
